const css = `html,
body {
  height: 100%;
  overflow: hidden;
}

select:focus {
  outline: none;
}

span {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 1vw;
}

input:focus {
  outline: none;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}

input[type=radio] {
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  margin: 0;
  margin-right: 8pt;
  padding: 0;
  font-size: 1.4vw;
  background-color: white;
  width: 1.2em;
  height: 1.2em;
  border: 1pt solid rgb(135, 135, 135);
  border-radius: 0.6em;
  transform: translateY(0.075em);
}

input[type=radio]:checked {
  background-color: white;
  border: 5pt solid rgb(91, 196, 126);
}

html,
body {
  height: 100%;
}

* {
  font-family: "Larsseit";
  touch-action: none;
}

span {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 1vw;
}

button > .disabled {
  background-color: rgb(212, 217, 226);
}
button > .disabled:hover {
  background-color: rgb(212, 217, 226);
}

div > .disabled span {
  color: rgb(212, 217, 226);
}
div > .disabled time {
  color: rgb(212, 217, 226);
}
div > .disabled h1,
div > .disabled h2,
div > .disabled h3,
div > .disabled h4,
div > .disabled h5,
div > .disabled h6 {
  color: rgb(212, 217, 226);
}

a {
  text-decoration: none;
}

b {
  font-weight: 700;
}

h1 {
  font-size: 4vw;
  margin: 0;
  font-weight: 400;
}

h2 {
  font-size: 3vw;
  margin: 0;
  font-weight: 400;
}

h3 {
  font-size: 2vw;
  margin: 0;
  font-weight: 400;
}

h4 {
  font-size: 1.4vw;
  margin: 0;
  font-weight: 400;
}

h5 {
  font-size: 1.25vw;
  margin: 0;
  font-weight: 400;
}

h6 {
  font-size: 1.1vw;
  margin: 0;
  font-weight: 400;
}

p {
  font-size: 1vw;
  margin: 0;
  font-weight: 400;
}

figure {
  margin: 0;
}

select {
  padding: 4pt;
  border-radius: 6pt;
  font-size: 1.25vw;
  background-color: white;
}

button,
input[type=submit],
input[type=reset] {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}

button {
  border-radius: 6pt;
  background-color: #1c344f;
  color: white;
  height: 5vh;
  width: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
button span {
  padding-left: 8pt;
  padding-right: 8pt;
  white-space: nowrap;
}
button [class^=icon-] {
  padding-left: 0;
  padding-right: 8pt;
}

input {
  border: 1pt solid #e0e0e0;
  padding: 8pt;
  padding-left: 0;
  padding-right: 0;
  /* min-width: %; */
  border-radius: 6pt;
  font-size: 1.25vw;
  text-align: center;
}
input:focus {
  outline: none;
}

.custom-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  height: 1.5em;
  width: 1.5em;
  border-radius: 50%;
  background: rgb(91, 196, 126);
  border: thin solid white;
  cursor: pointer;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvdWJ1bnR1L3ZlbnRpb24vbWEtcGFsbGV0aXplci9jbGllbnQvc3JjL3Njc3MiLCJzb3VyY2VzIjpbIkdsb2JhbC5zY3NzIiwiX21hc3Rlci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBO0FBQUE7RUFFQztFQUNBOzs7QUFJQTtFQUNDOzs7QUFJRjtFQzZHQztFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RURoSEEsV0M0Q2tCOzs7QUR4Q2xCO0VBQ0M7OztBQUlGO0FBQUE7RUFFQztFQUNBO0VBQ0E7RUFDQTs7O0FBR0Q7RUFFQztFQUNBO0VBQ0E7RUFDQTtFQUNBLGNDSlE7RURLUjtFQUNBLFdDZ0JhO0VEZmIsa0JDckJXO0VEc0JYLE9BVFk7RUFVWixRQVZZO0VBV1o7RUFDQTtFQUNBOzs7QUFHRDtFQUNDO0VBQ0E7OztBQUdEO0FBQUE7RUFFQzs7O0FBR0Q7RUFDQztFQUNBOzs7QUFHRDtFQzBEQztFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUQ3REEsV0NQa0I7OztBRFVuQjtFQUNDLGtCQzdEWTs7QUQ4RFo7RUFDQyxrQkMvRFc7OztBRG9FWjtFQUNDLE9DckVXOztBRHVFWjtFQUNDLE9DeEVXOztBRDBFWjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7RUFNQyxPQ2hGVzs7O0FEb0ZiO0VBQ0M7OztBQUdEO0VBQ0MsYUNwRFc7OztBRHNEWjtFQUNDLFdDbERZO0VEbURaO0VBQ0EsYUN4RGE7OztBRDBEZDtFQUNDLFdDdERlO0VEdURmO0VBQ0EsYUM3RGE7OztBRCtEZDtFQUNDLFdDekRjO0VEMERkO0VBQ0EsYUNsRWE7OztBRG9FZDtFQUNDLFdDN0RVO0VEOERWO0VBQ0EsYUN2RWE7OztBRHlFZDtFQUNDLFdDaEVZO0VEaUVaO0VBQ0EsYUM1RWE7OztBRDhFZDtFQUNDLFdDcEVhO0VEcUViO0VBQ0EsYUNqRmE7OztBRG1GZDtFQUNDLFdDeEVrQjtFRHlFbEI7RUFDQSxhQ3RGYTs7O0FEeUZkO0VBQ0M7OztBQUdEO0VBQ0M7RUFDQSxlQ2hIZTtFRGlIZixXQ3RGWTtFRHVGWjs7O0FBR0Q7QUFBQTtBQUFBO0VBR0M7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdEO0VBQ0MsZUNsSWU7RURtSWYsa0JDM0phO0VENEpiO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNDLGNDdklPO0VEd0lQLGVDeElPO0VEeUlQOztBQUdEO0VBQ0M7RUFDQSxlQzlJTzs7O0FEa0pUO0VBQ0MsUUM1SWtCO0VENklsQixTQ3BKUTtFRHFKUjtFQUNBO0FBQ0E7RUFDQSxlQzVKZTtFRDZKZixXQ2xJWTtFRG1JWjs7QUFFQTtFQUNDOzs7QUFJRjtFQUNDO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0EifQ== */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
